import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=f076445e&scoped=true&"
import script from "./AddressEdit.vue?vue&type=script&lang=js&"
export * from "./AddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=f076445e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f076445e",
  null
  
)

export default component.exports